import axios from "axios";
import AxiosInstance1 from "../AxiosInstance/AxiosInstance1";

{/* Added UniqueID by Gauri on 08 Feb 2025 */}
const GetPrioritizationCheckListHistory = async (
  IdeaId,
  currentPage,
  UniqueID,   // Passed UniqueID by Gauri on 08 Feb 2025 
  selectedBy,
  selectedField
) => {
  const accessToken = sessionStorage.getItem("access_token");
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const employeeId = userdata?.employeeId;
  const PageNo = currentPage;
  // Added by Gauri to add PageSize for History on 31 Oct 2025
  const PageSize = 5;
  if (!accessToken || !employeeId) {
    throw new Error("Access token or employee ID is missing. Please login again.");
  }

  try {
    console.log("Before API call");
    // Commented by Gauri to add PageSize for History on 31 Oct 2025
    // const response = await AxiosInstance1.get(
    //   `/api/InitiativeDetail/GetPrioritizationCheckListHistory`,
    //   {
    //     params: {
    //       IdeaId,
    //       PageNo,
    //       // Passed UniqueID by Gauri on 08 Feb 2025 
    //       UniqueID,
    //       ...(selectedBy && { ModifiedBy: selectedBy }),
    //       ...(selectedField && { ModifiedDate: selectedField })
    //     }
    //   }
    // );

    // Modified by Gauri to add PageSize for History on 31 Oct 2025
    const response = await AxiosInstance1.get(
      `/api/ChecklistMasters/GetCheckListMakerInboxHistory`,
      {
        params: {
          UniqueID,
          ...(selectedBy && { ModifiedBy: selectedBy }),
          ...(selectedField && { ModifiedField: selectedField }),
          PageNo,
          PageSize
        }
      }
    );

    if (response.status === 200) {
      console.log("After API call");
      console.log("history1", response.data);
      return response.data;
    } else {
      console.error("Non-200 response:", response.status);
    }
  } catch (error) {
    console.error("Error fetching initiative history:", error);
    throw new Error("Failed to fetch initiative history");
  }
};

export default GetPrioritizationCheckListHistory;
